import { RootState } from '../../../../stores/store';

export const organizationListSelector = (state: RootState) => state.listOfOrganization;
